import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton, TextField, Typography } from '@mui/material';
import ATab from '../../common/ATab';
import { useState } from 'react';
import UserTable from '../../common/UserTable';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Accounting } from '../../../enum/accounting';
import { MediaEntity } from '../../../enum/media_entity';
import { Company } from '../../../enum/company';
import { Ticket } from '../../../enum/ticket';
import { Campaign } from '../../../enum/campaign';
import axios from 'axios';
import IResponse from '../../../interfaces/response';
import BasicModal from '../../common/BasicModal';
import { FormatListBulleted } from '@mui/icons-material';
import { getFarsiNumber } from '../../../utils/number';

const ProfileGiver = () => {
	const { t } = useTranslation();
	const [activeItem, setActiveItem] = useState<string>(t('manage_pages'));
	let [openModal, setOpenModal] = useState<boolean>(false);
	let [priceModal, setPriceModal] = useState<boolean>(false);
	let [priceData, setPriceData] = useState<any | null>(null);
	let [refetch, setRefetch] = useState<boolean>(false);
	let [rejectReason, setRejectReason] = useState<string>('');
	let [selectId, setSelectId] = useState<number | null>(null);
	let { id } = useParams();
	const headerClassNames = 'text-xs bg-background-paper';
	let navigate = useNavigate();
	let closeModal = () => setOpenModal(!openModal);
	let closeModalPrice = () => setPriceModal(!priceModal);
	let changeStatus = (id: number | null, status: string) => {
		axios<IResponse<any>>({
			url: `admin/media-entities/${status === 'confirm' ? 'confirm' : 'reject'}/${id}`,
			method: 'post',
			data: { reject_reason: status === 'reject' ? rejectReason : '' },
		}).then(res => {
			if (res.data.success) {
				status === 'reject' && closeModal();
				setRefetch(true);
			}
		});
	};

	let rejectPage = () => {
		changeStatus(selectId, 'reject');
	};

	let handlePriceData = (data: any) => {
		setPriceModal(!priceModal);
		setPriceData(data);
	};

	let tabItem = [
		{
			title: t('manage_pages'),
			api: '/admin/media-entities',
			icon: <AccountBalanceWalletIcon />,
			permission: MediaEntity.Index,
			view: true,
			edit: false,
			viewAction: (id: number) => {
				navigate(`/my-social-media/edit/${id}?user_type=admin`);
			},
			editAction: () => {},
			columns: [
				{ field: 'title', flex: 1, headerName: t('group_and_channel_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'admin_name', flex: 1, headerName: t('admin_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'media',
					flex: 1,
					headerName: t('social'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						t(`${params.row.media}`);
					},
				},
				{
					field: 'influencer_campaign',
					headerName: t('view_in_search'),
					flex: 2,
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => (
						<FormGroup className="flex flex-row items-center justify-center pt-2">
							<FormControlLabel control={<Checkbox checked={params.row.view_campaign} />} label={t('view')} />
							<FormControlLabel control={<Checkbox checked={params.row.reserve_campaign} />} label={t('reserve')} />
							<FormControlLabel control={<Checkbox checked={params.row.influencer_campaign} />} label={t('influenceral')} />
						</FormGroup>
					),
				},
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 'confirmed' ? 'bg-green-50 text-green-600' : params.row.status === 'rejected' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>{params.row.status === 'confirmed' ? t('confirmed') : params.row.status === 'rejected' ? t('rejected') : t('confirmation_pend')}</div>;
					},
				},
				{
					field: 'change_status',
					headerName: t('change_status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						let data = params.row;
						return (
							<Box className="">
								<Button onClick={() => changeStatus(data.id, 'confirm')} className="mx-2">
									{t('confirm')}
								</Button>
								<Button
									onClick={() => {
										setSelectId(data.id);
										closeModal();
									}}
									color="error"
								>
									{t('cancel')}
								</Button>
							</Box>
						);
					},
				},
				{
					field: 'price',
					headerName: t('price'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						let data = params.row.prices;
						return (
							<IconButton onClick={() => handlePriceData(data)}>
								<FormatListBulleted className="text-text-secondary" />
							</IconButton>
						);
					},
				},
			],
		},
		{
			title: t('manage_companys'),
			api: '/admin/companies',
			icon: <AccountBalanceWalletIcon />,
			permission: Company.Index,
			columns: [
				{ field: 'title', flex: 1, headerName: t('company_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'admin_name', flex: 1, headerName: t('manager_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'created_at',
					flex: 1,
					headerName: t('created_time'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params.row.created_at).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'is_active',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.is_active === 1 ? 'bg-green-50 text-green-600' : 'bg-red-100 text-red-600'}`}>{params.row.is_active === 1 ? t('active') : t('inactive')}</div>;
					},
				},
			],
			route: 'admin/my-companies',
		},
		{
			title: t('finance'),
			api: '/admin/payments',
			icon: <AccountBalanceWalletIcon />,
			permission: Accounting.PaymentIndex,
			columns: [
				{ field: 'title', flex: 1, headerName: t('group_and_channel_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'admin_name', flex: 1, headerName: t('admin_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'social', flex: 1, headerName: t('social'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 'confirmed' ? 'bg-green-50 text-green-600' : params.row.status === 'rejected' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>{params.row.status === 'confirmed' ? t('confirmed') : params.row.status === 'rejected' ? t('rejected') : t('confirmation_pend')}</div>;
					},
				},
			],
		},
		{
			title: t('tickets'),
			api: '/admin/tickets',
			icon: <AccountBalanceWalletIcon />,
			permission: Ticket.Index,
			columns: [
				{ field: 'title', flex: 1, headerName: t('group_and_channel_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'admin_name', flex: 1, headerName: t('admin_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'social', flex: 1, headerName: t('social'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 'confirmed' ? 'bg-green-50 text-green-600' : params.row.status === 'rejected' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>{params.row.status === 'confirmed' ? t('confirmed') : params.row.status === 'rejected' ? t('rejected') : t('confirmation_pend')}</div>;
					},
				},
			],
		},
		{
			title: t('campaigns'),
			api: '/admin/campaigns',
			icon: <AccountBalanceWalletIcon />,
			permission: Campaign.Index,
			columns: [
				{ field: 'title', flex: 1, headerName: t('campaign_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'admin_name', flex: 1, headerName: t('title'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'social', flex: 1, headerName: t('media'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'created_at',
					flex: 1,
					headerName: t('created_time'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params.row.created_at).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 'confirmed' ? 'bg-green-50 text-green-600' : params.row.status === 'rejected' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>{params.row.status === 'confirmed' ? t('confirmed') : params.row.status === 'rejected' ? t('rejected') : t('confirmation_pend')}</div>;
					},
				},
			],
			route: 'admin/view',
		},
	];
	let filterItem = tabItem.find(item => item.title === activeItem);
	return (
		<Box className="w-full">
			<BasicModal open={priceModal} className="w-1/4" onClose={closeModalPrice}>
				<Typography className="text-center text-xl">{t('list_cost')}</Typography>
				<Box className="mt-5">
					{priceData?.map((item: any) => (
						<Typography className="flex justify-between">
							<span className="m-2 w-1/2 rounded-xl bg-gray-100 p-3 text-[15px]">{item.title}</span> <span className="m-2 w-1/2 rounded-xl bg-gray-100 p-3 text-end text-[15px]">{getFarsiNumber(item.price)}</span>
						</Typography>
					))}
					{!priceData?.length && <Typography className="m-2 p-3 text-center">{t('no_rows')}</Typography>}
				</Box>
			</BasicModal>
			<BasicModal open={openModal} className="w-1/4" onClose={closeModal}>
				<Typography className="text-center text-xl">{t('rejection_reason')}</Typography>
				<Box className="mt-5">
					<TextField onChange={e => setRejectReason(e.target.value)} label={t('rejection_reason')} className="my-2 w-full" multiline rows={5} maxRows={4} />
					<Button fullWidth onClick={() => rejectPage()}>
						{t('submit')}
					</Button>
				</Box>
			</BasicModal>
			<Box className="">
				<ATab items={tabItem} style="" active={activeItem} setActiveItem={setActiveItem} />
			</Box>
			<Box className="mt-7 w-full bg-white">
				<UserTable userId={id} refetch={refetch} activeItem={activeItem} tabItem={filterItem} />
			</Box>
		</Box>
	);
};

export default ProfileGiver;
